var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page--home"})
}
var staticRenderFns = []

export { render, staticRenderFns }